import React, { useMemo } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { ChildrenPropType } from '../../../prop-types/children';
import { MessageDescriptorPropType } from '../../../prop-types/intl';
import { LogService } from '../../../services/log-service';

import style from './section.module.less';

const OrderDetailsTabSection = ({ children, className, ariaLabelMessageDescriptor }) => {
  const { formatMessage } = useIntl();

  const ariaLabel = useMemo(() => {
    if (ariaLabelMessageDescriptor) {
      return formatMessage(ariaLabelMessageDescriptor);
    }

    LogService.logWarning('No aria-label provided for OrderDetailsTabSection');
  }, [ariaLabelMessageDescriptor, formatMessage]);

  return (
    <section aria-label={ariaLabel} className={classnames(style['order-details-section'], className)}>
      {children}
    </section>
  );
};

export { OrderDetailsTabSection };

OrderDetailsTabSection.propTypes = {
  children: ChildrenPropType.isRequired,
  className: PropTypes.string,
  ariaLabelMessageDescriptor: MessageDescriptorPropType.isRequired,
};
